import * as $ from "jquery";
import * as _ from "lodash";
import "select2";
import { ModuleCollection } from "../../../../../collections/Modules";
import { Utils } from "../../../../../common/utils";
import { DashboardChannel } from "../../../../../models/DashboardChannel";
import { ChartHelper } from "../../../../dashboard/widgets/chart/ChartHelper";
import {
    BaseModifyDashboardWidgetView,
    BaseModifyDashboardWidgetViewOptions,
    NewDashboardChannel
} from "../_BaseModifyWidgetView";

declare var App: any;

export class ModifySimpleWidgetView extends BaseModifyDashboardWidgetView {

    private widgetChannels: DashboardChannel[];
    // Template varies between dashboard and report widget modes
    protected template = _.template(require('templates/modals/dashboard/modify_widgets/simplewidget/simplewidget.html'));
    protected channelsTemplate = _.template(require('templates/modals/dashboard/modify_widgets/simplewidget/simplewidgetchannels.html'));

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any>_.merge({
            tagName: "div",
            className: 'widget-type-channels',
            events: {
                'click .add-channel-btn': 'handleAddChannelBtnClick',

                // Ranges
                'change .advanced-config-checkbox': 'handleConfigToggleChange',
                'click .add-threshold-btn': 'handleAddThreshold',
                'click .delete-threshold-btn, .delete-threshold-btn-mobile': 'handleDeleteThreshold',
                'input .threshold-name, .threshold-value': 'handleThresholdInput',
                'click .use-defaults-btn': 'handleUseDefaultsBtn',
                
                'change .custom-labels-config-checkbox': 'handleCustomLabelsToggleChange',
                
                // Chart Channel Changes
                'change .widget-channel-select-install': 'handleInstallSelectChange',
                'change .widget-channel-select-module': 'handleModuleSelectChange',
                'change .widget-channel-select-channel': 'handleChannelSelectChange',
                'click .widget-channel-delete': 'handleChannelDelete',
                'click .thresholds-minimized': 'handleThresholdClick',
                'input .thresholds input': 'handleThresholdsInput',
                'click .fa.fa-chevron-up.move-up': 'handleMoveChannelUp',
                'click .fa.fa-chevron-down.move-down': 'handleMoveChannelDown',
                'change .aggregation-period select': 'handleAggregationPeriodChange',
                'change .tab select': 'handleTabChange'
            }
        }, options));

        this.widgetChannels = null;
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: []
            });
            this.widgetChannels = [];
        } else {
            this.widgetChannels = this.options.dashboardChannelCollection.where({
                dashboard_widget_id: this.options.widget.get('id')
            });
        }
    }

    render() {
        const rawAdvancedConfig = this.options.widget.getParamValue('ADVANCED_CONFIG', false);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.advancedConfig = !!Number(rawAdvancedConfig);

        const rawUseCustomLabelsConfig = this.options.widget.getParamValue('USE_CUSTOM_LABELS', true);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.useCustomLabels = !!Number(rawUseCustomLabelsConfig);

        this.$el.html(this.template({
            dashboardCategoryCollection: this.options.dashboardCategoryCollection,
            dashboardTabCollection: this.options.dashboardTabCollection,
            widget: this.options.widget,
            report: this.options.report,
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels,
            channel_1_url: require('../../../../../../img/widgettypes/channels/channel_1.png'),
            categoryId: this.options.widget.get('dashboard_category_id') ?
                this.options.widget.get('dashboard_category_id') : this.options.categoryId,
            tabId: this.options.tabId
        }));
        this.$('select').select2(Utils.Select2.defaultOptions);
        //Initialize bootstrap toggle for advanced configuration
        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();

        if (!this.options.widget.isNew()) {
            this.buildInitialChannels();
        } else {
            this.renderNewChannelRow();
        }

        this.switchAggPeriod();
        return this;
    }

    show() {
        // Refit selects to container width after it is rendered on screen
        this.$('.channels').find('select').select2(Utils.Select2.defaultOptions);
        // Initialize tab select
        this.$('.tab select').select2(Utils.Select2.defaultOptions);
        // Initialize category select with tagging support for new categories
        this.initializeCategorySelect('.category select');
    }

    handleTabChange(e: JQuery.Event) {
        var $select = this.$('.tab select');
        var rawValue = $select.val();
        var tabId = rawValue === '' || rawValue === null || rawValue === undefined ? null : Number(rawValue);
        this.options.tabId = tabId;
        this.reloadCategoriesForTab(tabId);
    }

    checkCanSaveWidget() {
        var period = this.$('.aggregation-period select').val();
        var channelsForms = this.$('.channels');
        var savable = _.every(channelsForms, (form) => {
            var eachFieldHasChannel = false;
            var eachHasAgg = true;
            _.each($(form).children('.channel-selects'), (channel) => {
                var channelSelected = $(channel).find('.widget-channel-select-channel').val() !== '';
                eachFieldHasChannel = eachFieldHasChannel ? true : channelSelected;

                if (channelSelected && period !== '0') {
                    eachHasAgg = !eachHasAgg ? false : $(channel).find('.widget-channel-select-aggregation-type').val() !== '';
                }
            });
            return eachFieldHasChannel && eachHasAgg;
        });
        this.options.parentView.setSavable(savable);
    }

    protected setExampleImg() {
        var numChannels = this.$('.widget-channel-select-channel').length;
        var img = this.$('.example img');

        if (numChannels < 2) {
            img.attr('src', require('../../../../../../img/widgettypes/channels/channel_1.png'));
        } else {
            img.attr('src', require('../../../../../../img/widgettypes/channels/channel_2.png'));
        }
    }

    private handleAggregationPeriodChange() {
        this.switchAggPeriod();
    }

    private switchAggPeriod() {
        var aggBlock = this.$('.aggregation-wrapper');
        var val = this.$('.aggregation-period select').val();
        if (!val || val === '0') {
            aggBlock.css("display", "none");
        } else {
            aggBlock.css("display", "block");
            aggBlock.find('.widget-channel-select-aggregation-type').select2(Utils.Select2.defaultOptions);
        }
    }

    protected buildInitialChannels() {
        var widgetId = this.options.widget.get('id');
        var channels: any = _.sortBy(this.options.dashboardChannelCollection.where({ dashboard_widget_id: widgetId }), (dashboardChannel) => {
            return dashboardChannel.get('dashboard_channel_order');
        });
        var aggTypes = this.options.widget.getParamValue('CHART_AGGREGATION_TYPE', '').split(',');

        _.each(channels, (c: DashboardChannel) => {
            var installId = c.get('install_id');
            var dashboardChannelOrder = Number(c.get('dashboard_channel_order'));
            // Use channel's installId, rather than relying on App.getLastSelectedInstallId(), which caused errors
            var row = this.renderNewChannelRow(installId, dashboardChannelOrder, channels.length);

            function selectModuleChannel(row) {
                // Select the module
                row.find('.widget-channel-select-module').val(c.get('module_number')).trigger('change');

                // Select the channel
                row.find('.widget-channel-select-channel').val(c.get('channel_id')).trigger('change');
            }

            // Fill in the Dashboard Channel Id
            row.find('.widget-dashboard-channel-id').val(c.get('dashboard_channel_id'));

            // Select the install
            var installId = c.get('install_id');
            row.find('.widget-channel-select-install').val(installId).trigger('change');

            row.find('.widget-channel-select-channel').data('channelId', c.get('channel_id'));

            var moduleCollectionDeferred = this.options.moduleCollections[installId].getCollectionFetchPromise();
            $.when(moduleCollectionDeferred).done(() => {
                selectModuleChannel(row);
            });
            if (!this.options.moduleCollections[installId]) {
                row.hide();
            }

            var aggType = aggTypes[Number(c.get('dashboard_channel_order'))];
            row.find('.widget-channel-select-aggregation-type').val(aggType).trigger('change');
        });
    }

    preSave() {
        var aggregationTypesArr = _.map(this.$('.widget-channel-select-aggregation-type'), (type) => {
            return $(type).val();
        });

        this.options.widget.setParamValue('CHART_AGGREGATION_TYPE', aggregationTypesArr.join(','));
        this.options.widget.setParamValue('CHART_AGGREGATION_PERIOD', this.$('.aggregation-period select').val());
        this.options.widget.setParamValue('CHART_DATA_RANGE', ChartHelper.getDataRangeEquivalent(this.$('.aggregation-period select').val()));

        this.options.widget.setParamValue('ADVANCED_CONFIG', this.advancedConfig);
        this.options.widget.setParamValue('USE_CUSTOM_LABELS', this.useCustomLabels);
        this.options.widget.setParamValue('WIDGET_SIZE', this.$('.widget-size-selector').val());
        
        return true;
    }

    protected renderNewChannelRow(installId?: number, dashboardChannelOrder?: number, channelsLength?: number) {
        var newChannelRow = $(<string>this.channelsTemplate({
            organizationCollection: this.options.organizationCollection,
            installCollection: this.options.installCollection,
            lastSelectedInstallId: installId || App.getLastSelectedInstallId(),
            // Show move up arrow if the channel is not the first or only channel
            showMoveUp: !!(dashboardChannelOrder && channelsLength) || (dashboardChannelOrder && !(dashboardChannelOrder === channelsLength - 1)),
            // Show move down arrow if there is more than one channel and this channel is not the last channel
            showMoveDown: !!(channelsLength > 1 && dashboardChannelOrder < channelsLength - 1),
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels,
        }));
        this.$('.channels').append(newChannelRow);

        newChannelRow.find('.widget-channel-select-install').select2(Utils.Select2.defaultOptions);
        newChannelRow.find('.widget-channel-select-module').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));
        newChannelRow.find('.widget-channel-select-channel').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));
        newChannelRow.find('.widget-channel-select-aggregation-type').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));


        // Immediately trigger a change so that preselected installs cause modules to be fetched
        newChannelRow.find('.widget-channel-select-install').trigger('change');

        this.setExampleImg();
        this.switchAggPeriod()
        this.checkCanSaveWidget();
        return newChannelRow;
    }

    private handleMoveChannelUp(e: JQuery.UIEventBase) {
        var $target = $(e.currentTarget);
        var targetDashboardChannelId = $target.parents('.channel-selects').find('.widget-dashboard-channel-id').val();

        // Get dashboard_channel_order for this channel (by default, we know that the one above us is ours - 1)
        var targetDashboardChannel = this.options.dashboardChannelCollection.findWhere({ dashboard_channel_id: Number(targetDashboardChannelId) });
        var targetDashboardChannelOrder = targetDashboardChannel.get('dashboard_channel_order');

        // Get id of channel above this one, using the next lowest (numbered) from the current
        var previousDashboardChannelId = $target.parents('.channels').find('.channel-selects:nth-child(' + targetDashboardChannelOrder + ') .widget-dashboard-channel-id').val();
        var previousDashboardChannel = this.options.dashboardChannelCollection.findWhere({ dashboard_channel_id: Number(previousDashboardChannelId) });

        // Do ajax calls to swap dashboard_channel_order of two channels
        this.swapDashboardChannelOrder(targetDashboardChannel, previousDashboardChannel, () => {
            this.displayNewChannelOrder();
        });
    }

    private handleMoveChannelDown(e: JQuery.UIEventBase) {
        var $target = $(e.currentTarget);
        var targetDashboardChannelId = $target.parents('.channel-selects').find('.widget-dashboard-channel-id').val();

        // Get dashboard_channel_order for this channel (by default, we know that the one below us is ours + 1)
        var targetDashboardChannel = this.options.dashboardChannelCollection.findWhere({ dashboard_channel_id: Number(targetDashboardChannelId) });
        var targetDashboardChannelOrder = targetDashboardChannel.get('dashboard_channel_order');

        // Get id of channel below this one, using the next highest (numbered) from the current
        var nextDashboardChannelId = $target.parents('.channels').find('.channel-selects:nth-child(' + (targetDashboardChannelOrder + 2) + ') .widget-dashboard-channel-id').val();
        var nextDashboardChannel = this.options.dashboardChannelCollection.findWhere({ dashboard_channel_id: Number(nextDashboardChannelId) });

        // Do ajax calls to swap dashboard_channel_order of two channels
        this.swapDashboardChannelOrder(targetDashboardChannel, nextDashboardChannel, () => {
            this.displayNewChannelOrder();
        });
    }

    private swapDashboardChannelOrder(targetDashboardChannel, neighborDashboardChannel, cb) {
        var targetDashboardChannelOrder = targetDashboardChannel.get('dashboard_channel_order');
        var neighborDashboardChannelOrder = neighborDashboardChannel.get('dashboard_channel_order');

        $.when(
            this.updateChannel(targetDashboardChannel, neighborDashboardChannelOrder),
            this.updateChannel(neighborDashboardChannel, targetDashboardChannelOrder)
        ).done(() => {
            // Re-fetch collection so that new order displays in simple widget
            $.when(this.options.dashboardChannelCollection.getCollectionFetchPromise())
                .done(() => {
                    cb();
                });
        });
    }

    private updateChannel(channel, newDashboardChannelOrder) {
        var update = {};
        var dashboardChannelId = channel.get('dashboard_channel_id');

        update[dashboardChannelId] = <NewDashboardChannel>{
            dashboardId: this.options.dashboardId,
            widgetId: channel.get('dashboard_widget_id'),
            channelId: channel.get('channel_id'),
            order: newDashboardChannelOrder,
            secondary_order: channel.get('dashboard_channel_secondary_order'),
            name: channel.get('dashboard_channel_name'),
            critLow: null,
            warnLow: null,
            warnHigh: null,
            critHigh: null,
            rangesList: channel.get('rangesList')
        };

        return $.ajax({
            type: "PUT",
            url: this.options.dashboardChannelCollection.url() + '/',
            data: JSON.stringify({ update: update }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8"
        });
    }

    private displayNewChannelOrder() {
        this.$('.channels').empty();
        this.buildInitialChannels();
    }

    private handleAddChannelBtnClick(e) {
        e.preventDefault();
        this.renderNewChannelRow();
    }

    private buildModuleOptions(installId) {
        var options = [];
        this.options.moduleCollections[installId].each((module) => {

            // Filter Modules that don't have sensors connected. Control sensors are not
            // Considered sensors in this case
            for (var i = 1; i < 5; i++) {
                var con = module.getConnector(i);
                if (con) {
                    if (con['sensor_type'] === 29) continue;

                    var mod = module.get('module_number');
                    var option = { id: mod, text: module.getDisplayName(), selected: '' };
                    if (mod === App.getLastSelectedModuleNumber()) option.selected = "selected";
                    options.push(option);
                    break;
                }
            }
        });

        if (options.length) return [{ id: '', text: '' }].concat(options);
        return [{ id: '', text: 'No Modules Found' }]
    }

    private handleInstallSelectChange(e: JQuery.UIEventBase) {
        var installSelect = $(e.currentTarget);
        var installId = Number($(installSelect).val());

        if (!installId) return;

        // Save this as the last selected Id on the dashboard
        App.setLastSelectedInstallId(installId);

        var moduleSelect = installSelect.parents('.channel-selects').find('.widget-channel-select-module');
        moduleSelect.empty();

        if (this.options.permissionCollection.canViewInstall(Number(installId))) {
            if (!_.has(this.options.moduleCollections, installId)) {
                this.options.moduleCollections[installId] = new ModuleCollection([], { installId: installId });
                this.options.moduleCollections[installId].fetch();
            }

            if (this.options.moduleCollections[installId].isFetching()) {
                moduleSelect.append('<option value="">Loading...</option>');

                this.options.moduleCollections[installId].once('sync', () => {
                    moduleSelect.empty().select2(_.extend({
                        disabled: false,
                        data: this.buildModuleOptions(installId),
                    }, Utils.Select2.defaultOptions));
                    moduleSelect.trigger('change');
                });
            } else {
                moduleSelect.select2(_.extend({
                    disabled: !installId,
                    data: this.buildModuleOptions(installId),
                }, Utils.Select2.defaultOptions));
            }
        } else {
            moduleSelect.select2(_.extend({
                disabled: !installId,
            }, Utils.Select2.defaultOptions));
        }

        moduleSelect.trigger('change');
        this.checkCanSaveWidget();
    }

    private handleModuleSelectChange(e: JQuery.UIEventBase) {
        var moduleSelect = $(e.currentTarget);
        var moduleNumber = (<string>$(moduleSelect).val()) || "";
        var channelSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-channel');
        var installSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-install');
        var installId = (<string>$(installSelect).val());

        // Save this as the last selected module number on the dashboard
        App.setLastSelectedModuleNumber(moduleNumber);

        channelSelect.empty();
        var channelOptions = [{ id: '', text: '' }];
        if (moduleNumber) {
            var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            if (module) {
                _.each([1, 2, 3, 4], (connector) => {
                    var con = module.getConnector(connector);
                    if (con) {
                        var label = 'Connector ' + connector + ': ' + con['sensor_name'];
                        if (!module.showConnector(connector)) label += ' (disconnected)';

                        var optgroup = { text: label, children: [] };
                        _.each(_.sortBy(con.channels, 'channel_position'), (c) => {
                            optgroup.children.push({ id: c['channel_id'], text: c['channel_name'] });
                        });

                        channelOptions.push(<any>optgroup);
                    }
                });
            }
        }
        channelSelect.select2(_.extend({
            disabled: !moduleNumber.length,
            data: channelOptions,
        }, Utils.Select2.defaultOptions));
        channelSelect.trigger('change');
        this.checkCanSaveWidget();
    }

    protected handleChannelSelectChange(e: JQuery.UIEventBase) {
        var channelSelect = $(e.currentTarget);
        var container = $(channelSelect).parents('.channel-selects');
        var moduleSelect = container.find('.widget-channel-select-module');
        var moduleNumber = moduleSelect.val();
        var installSelect = container.find('.widget-channel-select-install');
        var useDefaultsButton = container.find('.use-defaults-btn');

        var channelNameInput = container.find('.widget-channel-label').val('');
        var channelAggType = container.find('.widget-channel-select-aggregation-type');
        var installId = (<string>$(installSelect).val());
        var channelId = Number(channelSelect.val());

        // Clear current ranges
        const thresholdsWrapper = container.find('.thresholds-wrapper');
        thresholdsWrapper.empty();
        const channelThresholdsRow = container.find('.channel-thresholds');
        this.setMultirangeThresholdQty(channelThresholdsRow);
        useDefaultsButton.prop('disabled', true);

        if (!channelId) {
            this.updateThresholdRow(container);
            channelNameInput.prop('disabled', true);
            channelAggType.prop('disabled', true);
            return;
        }

        // Enable defaults button
        useDefaultsButton.prop('disabled', false);
        var dashboardChannelId = container.find('.widget-dashboard-channel-id').val();
        var dashboardChannel = this.options.dashboardChannelCollection.findWhere({
            dashboard_channel_id: Number(dashboardChannelId),
            dashboard_widget_id: this.options.widget.get('id'),
            channel_id: channelId
        });
        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        var channel = module.getChannelById(channelId);
        var unit = channel['channel_unit'];
        var unitField = container.find('.thresholds .unit');

        if (dashboardChannel) {
            channelNameInput.val(dashboardChannel.get('dashboard_channel_name'));
            this.updateThresholdRow(container, channelId, dashboardChannel.get('rangesList'), unit);
        } else {
            this.updateThresholdRow(container, null, null, unit);
        }

        if (channelNameInput.val() == '') {
            channelNameInput.val( module.get('module_location') + ' - ' + channel['channel_name']);
        }

        var chartTitleField = $('.chart-title input');
        if (chartTitleField.val() === '') {
            chartTitleField.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }

        channelNameInput.prop('disabled', false);
        channelAggType.prop('disabled', false);
        this.checkCanSaveWidget();
        this.switchAggPeriod();
        unitField.val(unit);
    }

    private handleChannelDelete(e: JQuery.UIEventBase) {
        var channelContainer = $(e.currentTarget).parents('.channel-selects');
        // Remove elements generated by Spectrum Color Picker
        var colorPickerInputs = channelContainer.find('.threshold-range .threshold-color.color-picker');
        _.each(colorPickerInputs, (cp) => {
            var $cp = $(cp);
            (<any>$cp).spectrum("container").remove();
        });
        channelContainer.remove();
        this.checkCanSaveWidget();
        this.setExampleImg();
    }

    private handleThresholdClick(e: JQuery.UIEventBase) {
        var thresholdsContainer = $(e.currentTarget).parents('.channel-thresholds').find('.thresholds');
        var hidden = thresholdsContainer.hasClass('hidden');
        if (hidden) {
            thresholdsContainer.removeClass('hidden');
        } else {
            thresholdsContainer.addClass('hidden');
        }
    }

    private handleThresholdsInput(e: JQuery.UIEventBase) {
        var targetInput: any = $(e.currentTarget);
        var unit = targetInput.parents('.thresholds').find('.unit').val();

        var val = (<string>targetInput.val());
        var addClass = false;
        if (val == '') {
            val = 'N/A';
        } else {
            if (_.isNaN(Number(val))) {
                val = 'N/A';
            } else {
                val += unit;
                addClass = true;
            }
        }

        var allInputs = targetInput.parents('.thresholds').find('input');
        for (var i = 0; i < allInputs.length; i++) {
            if (allInputs.eq(i).is(targetInput)) break;
        }

        var badge = targetInput.parents('.channel-thresholds').find('.threshold-badges .badge:eq(' + i + ')');
        badge.text(val);
        if (addClass) {
            if (badge.hasClass('crit-low') || badge.hasClass('crit-high')) {
                badge.addClass('danger');
            } else {
                badge.addClass('warning');
            }
        } else {
            badge.removeClass('danger').removeClass('warning');
        }
    }

    getChannelDifference() {
        var channelsSeen = [];
        var create = [];
        var update = {};
        var rows = this.$('.channel-selects');
        _.each(rows, (row, i) => {
            var $row = $(row);
            var channelId = $row.find('.widget-channel-select-channel').val();

            var dashboardChannelIdField = $row.find('.widget-dashboard-channel-id');
            var dashboardChannelId = Number(dashboardChannelIdField.val());

            //If the row has no channelId, make sure not to delete it if its a result of not having permissions to view an install
            if (!channelId) {
                channelId = $row.find('.widget-channel-select-channel').data('channelId');
                if (channelId) channelsSeen.push(dashboardChannelId);
                return;
            }
            channelId = Number(channelId);

            var rangesList = this.advancedConfig ? this.getRangesListFromAdvancedThresholds(row) : this.getRangesListFromRegularThresholds(row);

            // Use default name or custom name based on configuration
            const installSelect = $row.find('.widget-channel-select-install');
            const installId = (<string>$(installSelect).val());
            const moduleNumber = $row.find('.widget-channel-select-module').val();
            const module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            const channel = module.getChannelById(channelId);
            let name = (<string>$row.find('.widget-channel-label').val()).trim();
            if(!this.useCustomLabels) name = `${module.get('module_location')} - ${channel['channel_name']}`;

            var upsert = {
                dashboardId: this.options.dashboardId,
                widgetId: this.options.widget.get('id'),
                channelId: channelId,
                order: i,
                name: name,
                critLow: null,
                warnLow: null,
                warnHigh: null,
                critHigh: null,
                rangesList: rangesList
            };
            if (dashboardChannelId) {
                channelsSeen.push(dashboardChannelId);

                // Make sure we had permission to update this channel
                if (!dashboardChannelIdField.attr('data-ignore-update')) update[dashboardChannelId] = upsert;
            } else {
                create.push(upsert)
            }
        });

        var _delete = [];
        _.each(this.widgetChannels, (c) => {
            var dcid = c.get('dashboard_channel_id');
            if (!_.includes(channelsSeen, dcid)) _delete.push(dcid);
        });

        return [create, update, _delete]
    }

    remove() {
        this.stopListening();
        return super.remove()
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/simplewidget/SimpleWidget.ts